module.exports = __webpack_public_path__ + "static/media/nhu.31fe30fe.jpeg";